import store from './store';

export default{
 
  getMenuItems()
  {
      let menuItem;
      let auth = store.getters.getAuth;

      let menuItemAdmin = {
        text: "관라자",
        icon: "preferences",
        items: [
          {text: "사용자 정보",
            path: "/ausr"},
          {text: "스페이스 권한 정보",
            path: "/aath"},
          {text: "로그인 이력",
            path: "/avul"},
          {text: "스페이스 정보",
            path: "/aspc"},
          {text: "맵 정보",
            path: "/amap"},
          {text: "오브젝트 정보",
            path: "/aobj"},
          {text: "이벤트 로우 데이터 정보",
            path: "/aerd"}
        ]
      }  
    
      menuItem = [
        {
           text: "바로가기",
           icon: "home",
           items: [{text: "HOME",
                    path: "/home"}]
        },
        {
          text: "조회",
          icon: "rowfield",
          items: [{text: "맵/콘텐츠 통계",
                   path: "/uvmc"},
                  {text: "시간/일/주/월 접속자 통계",
                   path: "/uvtm"}]
        }
      ] 
   
      if(auth == 'ADMIN'){
        menuItem.push(menuItemAdmin); 
      }
 
      return menuItem;
  }
}